export default "__VITE_ASSET__8c0d0c73__"